//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import wx from 'weixin-js-sdk'

export default {
    name: 'problem',
    components: {
        wx
    },
    data() {
        return {
            filePath: [],
            formData:{
                order_id:0,
                content:'',
                pics:[],
            },
        }
    },
    created() {
        this.formData.order_id = Number(this.$route.params.id);
        this.config();
    },
    methods: {
        submit() {
            if(!this.formData.pics.length){
                this.$func.showToast('请输入上传照片');
                return false;
            }
            if(!this.formData.content){
                this.$func.showToast('请输入问题描述');
                return false;
            }
            this.$api.problem(this.formData).then((res)=>{
                this.$func.showToast('提交成功');
                setTimeout(()=>{
                    this.$router.go(-1);
                },1000)
            });
        },
        config(){
            // var url= '';
            // var u = navigator.userAgent;
            // var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
            // if (isIOS) {
            //     url=window.entryUrl
            // }else{
            //     url = window.location.href;
            // }
             let url = (window.location.href).split('#');
            if(url[0].indexOf('?') != '-1'){
                url = url[0].split('?');
            }
            this.$api.wxSign({url:url[0]}).then((res)=>{
                if(res){
                    wx.config({
                        debug: false, //调试阶段建议开启
                        appId: res.data.appId,
                        timestamp: res.data.timestamp,
                        nonceStr: res.data.nonceStr,
                        signature:res.data.signature,
                        jsApiList: [
                            "chooseImage",
                            "uploadImage",
                        ]
                    });
                }
            })
        },
        uploadFile(){
            let that = this;
            wx.chooseImage({
                    count: 9,
                    sizeType: ['original', 'compressed'], 
                    sourceType: ['album', 'camera'], 
                    success: function (res) {
                        that.uploadImg(res.localIds);
                    }
                });
            },
        uploadImg(localIds){
            let localId = localIds.pop();
            let that = this;
            wx.uploadImage({
                localId: localId, 
                success: function (res) {
                that.$api.uploadsImg({serverId:res.serverId}).then((res)=>{
                    if(res){
                    that.filePath.push(res.data.url);
                    that.formData.pics.push(res.data.path);
                    if(localIds.length > 0){
                        that.uploadImg(localIds);
                    }
                    }
                })
                }
            });
        },
        showPic(index) {
            wx.previewImage({
                current: this.filePath[index], // 当前显示图片的http链接
                urls: this.filePath // 需要预览的图片http链接列表
            });
        },
        delImg(index){
            this.filePath.splice(index,1);
            this.formData.pics.splice(index,1);
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/problem.vue